import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import { OutboundLink } from "gatsby-plugin-google-gtag"
import Social from "./social-footer"

const Footer = () => {
  const data = useStaticQuery(graphql`
    query FooterQuery {
      site {
        siteMetadata {
          title
        }
      }
      wpMenu(slug: { eq: "footer" }) {
        menuItems {
          nodes {
            label
            url
            parentId
            connectedNode {
              node {
                ... on WpContentNode {
                  uri
                }
              }
            }
          }
        }
      }
    }
  `)

  return (
    <footer>
      <div id="footer-account">
        <div className="container">
          <h3>Create an Account</h3>
          <OutboundLink href="https://portal.artandwriting.org/" className="button">
            Get Started
          </OutboundLink>
        </div>
      </div>
      <div id="footer-links">
        <ul>
          {data.wpMenu.menuItems.nodes.map((menuItem, i) => {
            let weight
            const path = menuItem?.connectedNode?.node?.uri ?? menuItem.url

            const lastThree = [6, 7, 8]



            if (menuItem.label === "Press") {
              return (
                <li key={i} className={weight} >
                  <OutboundLink href={path}>
                    {menuItem.label}
                  </OutboundLink>
                </li>
              )
            }

            if (menuItem.label === "Newsletter") {
              return (
                <li key={i} className={weight} >
                  <OutboundLink href={path}>
                    {menuItem.label}
                  </OutboundLink>
                </li>
              )
            }

            if (menuItem.label === "Blog") {
              return (
                <li key={i} className={weight} >
                  <OutboundLink href={path}>
                    {menuItem.label}
                  </OutboundLink>
                </li>
              )
            }

            else if (lastThree.includes(i)) {
              return (
                <li key={i} className="other" >
                  <Link to={path}>
                    {menuItem.label}
                  </Link>
                </li>
              )
            } else {
              return (
                <li key={i} className={weight} >
                  <Link to={path}>
                    {menuItem.label}
                  </Link>
                </li>
              )
            }


          })}
        </ul>
        <div id="footer-fine">
          <span dangerouslySetInnerHTML={{ __html: "&copy;" }} /> {new Date().getFullYear()} Alliance for Young Artists & Writers, New York, NY  | <Link to="/credits">Credits</Link> | Design by <OutboundLink href="https://www.bandwidthproductions.com" rel="noreferrer" target="_blank" >Bandwidth Productions</OutboundLink>
        </div>
      </div>


      <div id="footer-newsletter">
        <div id="footer-newsletter-container">
          <div className="cta">

          <svg
      width={540}
      height={104}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"

    >
      <path
        d="M13.657 17.124c8.194 1.103 12.974 2.941 12.974 10.978 0 7.459-4.412 12.554-14.97 12.554-3.94 0-8.982-.893-11.661-2.259v-5.883c2.154.946 5.936 2.574 11.293 2.574 7.091 0 9.193-2.889 9.193-6.618 0-4.36-1.839-5.41-7.144-6.093C3.729 21.169 0 18.595 0 11.398 0 5.62 3.257 0 13.972 0c5.095 0 8.667.893 10.663 1.891v5.725c-2.889-1.26-6.46-2.048-10.348-2.048-6.145 0-8.246 2.521-8.246 5.883 0 4.255 2.416 4.99 7.616 5.673zM39.749 40.393c-4.78 0-6.934-2.31-6.934-6.828V13.762h5.883v19.75c0 1.471.526 1.996 2.206 1.996v4.78s-.525.105-1.155.105zM31.922 5.988c0-2.101 1.734-3.834 3.835-3.834 2.1 0 3.834 1.733 3.834 3.834s-1.733 3.835-3.834 3.835-3.835-1.734-3.835-3.835zM67.264 23.112c0 5.988-2.941 9.98-10.978 9.98-1.103 0-2.153-.052-3.046-.21-.42.42-.736.998-.736 1.523 0 .893.473 1.366 1.576 1.524l9.508 1.155c5.2.63 7.038 2.994 7.038 7.354 0 6.776-7.144 9.35-14.76 9.35-7.039 0-12.134-2.259-12.134-7.67 0-3.57 2.68-5.672 5.463-6.513v-.052c-1.313-.735-2.048-2.206-2.048-3.624 0-1.944 1.155-3.31 2.363-4.255-2.994-1.681-4.202-4.727-4.202-8.562 0-5.988 2.941-9.98 10.978-9.98 1.891 0 3.467.21 4.833.63h9.087v3.73l-3.73 1.05c.526 1.366.788 2.89.788 4.57zm-5.357 18.647l-7.46-.945c-2.678.472-5.094 1.68-5.094 4.202 0 2.941 2.1 4.097 6.933 4.097 4.623 0 8.667-1.366 8.667-4.517 0-1.786-.893-2.574-3.046-2.837zM50.876 23.112c0 2.994.998 5.305 5.41 5.305 4.413 0 5.41-2.311 5.41-5.305 0-2.994-.997-5.305-5.41-5.305-4.412 0-5.41 2.31-5.41 5.305zM96.334 40.026H90.45V22.009c0-2.679-1.366-3.887-4.15-3.887-2.731 0-4.622.735-6.04 1.523v20.38h-5.884V13.763h3.467l.946 2.101c2.678-1.838 5.672-2.731 8.509-2.731 6.671 0 9.035 3.309 9.035 8.352v18.542zM113.279 13.762h5.884V31.78c0 2.679 1.365 3.887 4.149 3.887 2.732 0 4.623-.735 6.041-1.523v-20.38h5.883v26.263h-3.467l-.945-2.101c-2.679 1.838-5.673 2.731-8.51 2.731-6.671 0-9.035-3.31-9.035-8.352V13.762zM154.483 40.656c-2.627 0-5.148-.84-7.039-2.048v14.55h-5.883V13.762h3.467l.945 2.101c2.311-1.68 4.99-2.731 8.51-2.731 7.669 0 10.505 5.147 10.505 13.762 0 8.562-2.836 13.762-10.505 13.762zm-1.366-4.99c5.148 0 5.935-3.94 5.935-8.772 0-4.885-.787-8.772-5.935-8.772-2.784 0-4.623.945-5.673 1.523v14.498c1.05.578 2.889 1.523 5.673 1.523zM198.773.63v4.99c-.946-.315-2.049-.525-3.887-.525-2.627 0-4.728.998-4.728 3.992v4.675h7.407v4.99h-7.407v21.274h-5.883V18.752h-4.78v-3.624l4.78-1.366v-5.2c0-5.62 3.152-8.562 10.191-8.562 1.733 0 3.309.263 4.307.63zM212.078 35.718c4.99 0 5.726-3.204 5.726-8.824 0-5.62-.736-8.825-5.726-8.825s-5.725 3.204-5.725 8.825c0 5.62.735 8.825 5.725 8.825zm0 4.938c-9.35 0-11.661-5.673-11.661-13.762 0-8.09 2.311-13.762 11.661-13.762s11.661 5.673 11.661 13.762c0 8.09-2.311 13.762-11.661 13.762zM244.822 13.447v5.043c-.63-.21-1.681-.316-2.889-.316-3.099 0-5.41.736-6.723 1.576v20.276h-5.884V13.762h3.467l.946 2.101c1.943-1.576 4.885-2.731 8.299-2.731 1.103 0 2.049.157 2.784.315zM13.657 79.5c8.194 1.103 12.974 2.942 12.974 10.978 0 7.459-4.412 12.554-14.97 12.554-3.94 0-8.982-.893-11.661-2.259V94.89c2.154.946 5.936 2.574 11.293 2.574 7.091 0 9.193-2.889 9.193-6.618 0-4.36-1.839-5.41-7.144-6.093C3.729 83.545 0 80.97 0 73.775c0-5.779 3.257-11.399 13.972-11.399 5.095 0 8.667.893 10.663 1.891v5.726c-2.889-1.261-6.46-2.049-10.348-2.049-6.145 0-8.246 2.521-8.246 5.883 0 4.255 2.416 4.99 7.616 5.673zM37.49 89.27c0 5.095 1.47 8.562 6.566 8.562 3.047 0 4.99-.473 6.881-1.208v5.095c-2.048.893-4.517 1.313-7.249 1.313-9.297 0-12.134-5.568-12.134-13.762s2.837-13.762 12.134-13.762c2.732 0 5.2.42 7.249 1.313v5.095c-1.89-.735-3.834-1.208-6.881-1.208-5.095 0-6.566 3.467-6.566 8.562zM72.536 84.385c0-2.679-1.366-3.887-4.15-3.887-2.731 0-4.622.735-6.04 1.523v20.381h-5.883V63.006h5.883v14.445c2.048-1.208 4.36-1.943 7.038-1.943 6.671 0 9.035 3.31 9.035 8.352v18.542h-5.883V84.385zM95.46 98.095c4.99 0 5.725-3.205 5.725-8.825 0-5.62-.735-8.825-5.725-8.825-4.99 0-5.726 3.205-5.726 8.825 0 5.62.736 8.825 5.726 8.825zm0 4.937c-9.35 0-11.661-5.673-11.661-13.762 0-8.09 2.31-13.762 11.66-13.762s11.662 5.673 11.662 13.762c0 8.09-2.312 13.762-11.661 13.762zM120.167 102.77c-4.78 0-6.934-2.312-6.934-6.829V63.006h5.883v32.882c0 1.471.525 1.996 2.206 1.996v4.78s-.525.106-1.155.106zM141.274 84.28c0-2.679-1.261-3.73-5.148-3.73-3.414 0-6.198.788-8.194 1.576v-5.095c2.049-.893 5.515-1.523 8.615-1.523 8.614 0 10.61 3.782 10.61 9.35v17.544h-3.467l-.945-2.101c-2.101 1.733-5.043 2.731-7.932 2.731-6.776 0-9.035-4.202-9.035-8.404 0-5.673 3.677-8.09 9.613-8.562l5.883-.473V84.28zm0 5.358l-5.515.63c-2.627.315-4.15 1.313-4.15 4.045 0 1.996.84 3.887 4.045 3.887 2.363 0 3.992-.683 5.62-1.734v-6.828zM158.35 83.702c0 1.839.946 2.627 4.36 2.942 7.879.682 9.928 3.046 9.928 7.931 0 4.518-2.784 8.457-11.189 8.457-3.624 0-6.881-.683-8.667-1.418v-5.043c1.734.63 4.518 1.471 7.827 1.471 4.202 0 6.251-.945 6.251-3.257 0-1.943-.841-2.941-4.36-3.256-7.932-.683-9.875-3.152-9.875-7.67 0-4.517 2.941-8.351 10.663-8.351 3.572 0 6.093.42 8.142 1.313v5.095c-2.259-.84-4.728-1.47-8.037-1.47-3.099 0-5.043.892-5.043 3.256zM193.325 97.832v4.832c-.893.211-2.364.368-3.256.368-5.831 0-9.245-2.521-9.245-8.194v-13.71h-4.78v-3.624l4.78-1.366v-6.25l5.883-1.681v7.931h7.406v4.99h-7.406v13.027c0 2.626 1.313 3.887 4.307 3.887.893 0 1.681-.105 2.311-.21zM206.188 102.77c-4.78 0-6.933-2.312-6.933-6.829V76.138h5.883v19.75c0 1.471.525 1.996 2.206 1.996v4.78s-.525.106-1.156.106zm-7.826-34.406c0-2.1 1.733-3.834 3.834-3.834s3.835 1.733 3.835 3.834-1.734 3.835-3.835 3.835-3.834-1.734-3.834-3.835zM217.946 89.27c0 5.095 1.47 8.562 6.566 8.562 3.046 0 4.99-.473 6.881-1.208v5.095c-2.049.893-4.518 1.313-7.249 1.313-9.297 0-12.134-5.568-12.134-13.762s2.837-13.762 12.134-13.762c2.731 0 5.2.42 7.249 1.313v5.095c-1.891-.735-3.835-1.208-6.881-1.208-5.096 0-6.566 3.467-6.566 8.562zM270.966 102.402l-2.784-9.613h-12.606l-2.784 9.613h-6.409l12.502-39.868h5.988l12.502 39.868h-6.409zm-4.044-14.445l-5.043-17.44-5.043 17.44h10.086zM296.448 83.072l-5.463 19.803h-4.99l-6.881-26.737h5.988l3.572 18.07 5.095-18.07h5.358l5.095 18.07 3.572-18.07h5.988l-6.881 26.737h-4.99l-5.463-19.803zM331.938 84.28c0-2.679-1.261-3.73-5.148-3.73-3.414 0-6.198.788-8.194 1.576v-5.095c2.048-.893 5.515-1.523 8.614-1.523 8.615 0 10.611 3.782 10.611 9.35v17.544h-3.467l-.946-2.101c-2.101 1.733-5.042 2.731-7.931 2.731-6.776 0-9.035-4.202-9.035-8.404 0-5.673 3.677-8.09 9.613-8.562l5.883-.473V84.28zm0 5.358l-5.516.63c-2.626.315-4.149 1.313-4.149 4.045 0 1.996.84 3.887 4.044 3.887 2.364 0 3.992-.683 5.621-1.734v-6.828zM359.467 75.823v5.043c-.631-.21-1.681-.316-2.889-.316-3.099 0-5.411.736-6.724 1.576v20.276h-5.883V76.138h3.467l.946 2.101c1.943-1.576 4.885-2.731 8.299-2.731 1.103 0 2.048.157 2.784.315zM373.503 75.508c2.626 0 5.147.84 7.038 2.049v-14.55h5.883v39.395h-3.466l-.946-2.101c-2.311 1.681-4.99 2.731-8.509 2.731-7.669 0-10.506-5.147-10.506-13.762 0-8.562 2.837-13.762 10.506-13.762zm1.365 4.99c-5.147 0-5.935 3.94-5.935 8.772 0 4.885.788 8.772 5.935 8.772 2.784 0 4.623-.945 5.673-1.523V82.02c-1.05-.578-2.889-1.523-5.673-1.523zM397.77 83.702c0 1.839.945 2.627 4.36 2.942 7.879.682 9.927 3.046 9.927 7.931 0 4.518-2.784 8.457-11.188 8.457-3.624 0-6.881-.683-8.667-1.418v-5.043c1.733.63 4.517 1.471 7.826 1.471 4.203 0 6.251-.945 6.251-3.257 0-1.943-.84-2.941-4.36-3.256-7.931-.683-9.875-3.152-9.875-7.67 0-4.517 2.942-8.351 10.663-8.351 3.572 0 6.094.42 8.142 1.313v5.095c-2.259-.84-4.727-1.47-8.037-1.47-3.099 0-5.042.892-5.042 3.256zM450.667 102.402h-5.883V84.385c0-2.679-1.366-3.887-4.15-3.887-2.731 0-4.622.735-6.041 1.523v20.381h-5.883V76.138h3.467l.946 2.101c2.679-1.838 5.673-2.731 8.509-2.731 6.671 0 9.035 3.31 9.035 8.352v18.542zM456.046 89.27c0-8.457 3.099-13.762 11.661-13.762 9.245 0 10.716 6.093 10.716 13.342 0 .893-.053 1.733-.105 2.574h-16.336c.105 3.94 1.523 6.513 6.881 6.513 3.309 0 6.041-.578 8.352-1.576v5.043c-2.994 1.26-6.409 1.628-9.245 1.628-8.772 0-11.924-5.253-11.924-13.762zm11.661-8.667c-4.307 0-5.515 2.784-5.725 6.724h10.505c0-3.572-.21-6.724-4.78-6.724zM498.961 83.072l-5.463 19.803h-4.99l-6.881-26.737h5.988l3.572 18.07 5.095-18.07h5.358l5.095 18.07 3.572-18.07h5.988l-6.881 26.737h-4.99l-5.463-19.803zM525.713 83.702c0 1.839.945 2.627 4.359 2.942 7.879.682 9.928 3.046 9.928 7.931 0 4.518-2.784 8.457-11.188 8.457-3.625 0-6.881-.683-8.667-1.418v-5.043c1.733.63 4.517 1.471 7.826 1.471 4.202 0 6.251-.945 6.251-3.257 0-1.943-.84-2.941-4.36-3.256-7.931-.683-9.875-3.152-9.875-7.67 0-4.517 2.942-8.351 10.663-8.351 3.572 0 6.093.42 8.142 1.313v5.095c-2.259-.84-4.728-1.47-8.037-1.47-3.099 0-5.042.892-5.042 3.256z"
        fill="#fff"
      />
    </svg>

          </div>
          <div className="cta-button">
            

            <OutboundLink
                href="https://mailing.artandwriting.org/h/t/6DF05480A0EF342C"
                rel="external"
                title="Subscribe to our Newsletter"
                target="_blank"
>
<div className="blue button">SUBSCRIBE</div> 
         </OutboundLink>
          </div>
          <div className="socials">

            <Social />


          </div>
        </div>



      </div>

    </footer>
  )
}

export default Footer
